import { motion, useReducedMotion } from 'framer-motion';
import { CameraIcon } from 'lucide-react';
import { ease } from '../../../core/format/motion';
type Props = {
  week: number;
  hasEntries: boolean;
  onCamera: () => void;
  /** Alleen in de demo: een voorbeeldfoto in plaats van de camera. */
  onSample?: () => void;
};

/** Vanaf het dashboard binnengekomen: de foto-stap staat meteen klaar. Een camera mag niet vanzelf openen. */
export function DiaryPrompt({
  week,
  hasEntries,
  onCamera,
  onSample
}: Props) {
  const reduce = useReducedMotion();
  return <motion.section initial={reduce ? {
    opacity: 0
  } : {
    opacity: 0,
    height: 0
  }} animate={reduce ? {
    opacity: 1
  } : {
    opacity: 1,
    height: 'auto'
  }} exit={reduce ? {
    opacity: 0
  } : {
    opacity: 0,
    height: 0
  }} transition={{
    duration: 0.24,
    ease
  }} className="mb-8 overflow-hidden" aria-labelledby="diary-prompt-title" data-id="element-6280" data-mp="1rd5zp9l8vac7">
      <div className="flex flex-col gap-4 bg-ink p-5 text-shell sm:flex-row sm:items-center sm:justify-between sm:p-6" data-id="element-6281" data-mp="2a4qffb0a3o87">
        <div data-id="element-6282" data-mp="22gd67u8xvu25">
          <h2 id="diary-prompt-title" className="font-display text-[22px] font-light" data-id="element-6283" data-mp="22gwkn0zds0bf">
            {hasEntries ? `Klaar voor je foto van week ${week}?` : 'Klaar voor je startfoto?'}
          </h2>
          <p className="mt-1 text-[14px] text-shell/75" data-id="element-6284" data-mp="1shnuykbjt7uv">
            {hasEntries ? 'Ga bij hetzelfde raam staan als de vorige keer.' : 'Kies een raam met daglicht. Daar sta je de volgende keren ook.'}
          </p>
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-6285" data-mp="2l7nrnvvwbemn">
          <button type="button" onClick={onCamera} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-shell px-5 py-3 text-[14px] text-ink transition-colors duration-150 ease-soft hover:bg-blush" data-id="element-6286" data-mp="2g7rmhtbgph5i">
            <CameraIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-6287" data-mp="33w13mhxqdgqb" />
            Open camera
          </button>
          {onSample && <button type="button" onClick={onSample} className="whitespace-nowrap rounded-full px-4 py-3 text-[13px] text-shell/80 underline-offset-4 hover:underline" data-id="element-6288" data-mp="2z41ap9g2vo38">
              Voorbeeldfoto (demo)
            </button>}
        </div>
      </div>
    </motion.section>;
}